"use client"

import { useEffect, useRef } from "react"
import { useAuth } from "@/hooks/auth/use-auth"

type MicrosoftClarityProps = {
  projectId: string
}

/** Loads Clarity only after hydration; the project ID is intentionally server-configured. */
export function MicrosoftClarity({ projectId }: MicrosoftClarityProps) {
  const { user, isAuthenticated } = useAuth()
  const email = isAuthenticated ? user?.email : undefined
  const initializedProject = useRef<string | null>(null)

  useEffect(() => {
    if (!projectId) return

    let cancelled = false
    void import("@microsoft/clarity").then(({ default: clarity }) => {
      if (cancelled) return
      if (initializedProject.current !== projectId) {
        clarity.init(projectId)
        initializedProject.current = projectId
      }
      if (email) clarity.identify(email)
    }).catch(() => {
      // Analytics must not interrupt the app if the SDK cannot load.
    })

    return () => {
      cancelled = true
    }
  }, [projectId, email])

  return null
}
